/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC165__factory } from "./ERC165__factory";
export { IERC165__factory } from "./IERC165__factory";
